export const FORGOT_PASSWORD = '/user/forgot-password/'
export const REGISTER_ACCOUNT = '/signup/'
export const CONTACT_SUPPORT_LOGIN =
  'mailto:helpdesk@ten-x.com?subject=Morpheus Login Assistance'
